// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---blog-theme-src-templates-article-template-tsx": () => import("./../../../../blog-theme/src/templates/article.template.tsx" /* webpackChunkName: "component---blog-theme-src-templates-article-template-tsx" */),
  "component---blog-theme-src-templates-articles-template-tsx": () => import("./../../../../blog-theme/src/templates/articles.template.tsx" /* webpackChunkName: "component---blog-theme-src-templates-articles-template-tsx" */),
  "component---blog-theme-src-templates-author-template-tsx": () => import("./../../../../blog-theme/src/templates/author.template.tsx" /* webpackChunkName: "component---blog-theme-src-templates-author-template-tsx" */)
}

